import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.scss';
import SaleOrderAjax from "./SaleOrderAjax";

const root = ReactDOM.createRoot(document.getElementById('SaleOrderAjax'));
root.render(
    <SaleOrderAjax/>
);

